// removed by extract-text-webpack-plugin
module.exports = {"CategoryContainer":"CategoryContainer__1bq6I","ClickSurface":"ClickSurface__6nb1Z","CategoryText":"CategoryText__NqUdm","ImageWrapper":"ImageWrapper__2cIS9","CategoryIcon":"CategoryIcon__3pU8P"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/CategoryButton/style.scss
// module id = 7WtF
// module chunks = 0